export default __webpack_public_path__ + "static/media/spectra-com16.d468f56f.jpg";